import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const BioSampleCollectPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-collection/page/BioSampleCollectPage'),
);
const BioSampleAliquotPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-aliquot/page/BioSampleAliquotPage'),
);
const BioSampleMultiAliquotPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-aliquot/page/BioSampleMultiAliquotPage'),
);
const BioSampleProcessPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-processing/page/BioSampleProcessPage'),
);
const BioSampleShippingPage = React.lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-shipping/page/BioSampleShippingPage'),
);

const toRelativePath = (absolutePath: CspPath): string => PathUtil.toRelativePath(CspPath.HBS, absolutePath, true);

export const BioSamplingRoutes: RouteObject[] = [
  {
    children: [
      {
        path: toRelativePath(CspPath.HBS_COLLECT_SAMPLES),
        element: <BioSampleCollectPage />,
      },
      {
        path: toRelativePath(CspPath.HBS_ALIQUOT_SAMPLES),
        element: <BioSampleAliquotPage />,
      },
      {
        path: toRelativePath(CspPath.HBS_PROCESS_SAMPLES),
        element: <BioSampleProcessPage />,
      },
      {
        path: toRelativePath(CspPath.HBS_SHIP_SAMPLES),
        element: <BioSampleShippingPage />,
      },
      {
        path: toRelativePath(CspPath.HBS_MULTI_ALIQUOT_SAMPLES),
        element: <BioSampleMultiAliquotPage />,
      },
      {
        path: '*',
        element: <Navigate to={CspPath.PATIENT_LIST_HBS} replace />,
      },
    ],
  },
];
